/**
 * Vista: Lista de Carnets de Servicio
 * Formatos: AMX-PVTA-FR-01 (No Certificado) y AMX-PVTA-FR-05 (Certificado)
 */

import posventaService from '../services/posventa.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';
import modal from '../utils/modal.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">Carnets de Servicio</h2>
          ${permisos.canCreate('servicios') ? `<button class="btn btn-primary" onclick="router.navigate('/posventa/carnets/nuevo')">
            + Nuevo Carnet
          </button>` : ''}
        </div>

        <!-- Estadísticas -->
        <div id="statsContainer" class="stats-container" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statTotal" style="font-size: 1.5rem; font-weight: bold;">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Total Carnets</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statCertificados" style="font-size: 1.5rem; font-weight: bold; color: var(--success);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Certificados</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statNoCertificados" style="font-size: 1.5rem; font-weight: bold; color: var(--warning);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">No Certificados</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statServiciosPendientes" style="font-size: 1.5rem; font-weight: bold; color: var(--info);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Servicios Próximos</div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input type="text" id="busqueda" class="form-input" placeholder="Num. Serie, Propietario..." />
          </div>
          <div class="form-group">
            <label class="form-label">Tipo</label>
            <select id="tipoFilter" class="form-input">
              <option value="">Todos</option>
              <option value="certificado">Certificado</option>
              <option value="no_certificado">No Certificado</option>
            </select>
          </div>
          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.carnetsListView.limpiarFiltros()" style="width: 100%;">
              Limpiar Filtros
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 40px;"></th>
                <th>Num. Serie</th>
                <th class="tbl-hide-mobile">Modelo</th>
                <th class="tbl-hide-mobile">Propietario</th>
                <th class="tbl-hide-mobile">Tipo</th>
                <th class="tbl-hide-mobile">Servicios</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="carnetsTableBody">
              <tr>
                <td colspan="8" style="text-align: center; padding: 2rem;">Cargando carnets...</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination" style="margin-top: 1rem;"></div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('servicios')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.carnetsListView = this;

    this.currentPage = 1;
    this.limit = 10;
    this.filters = {};
    this.intervalosServicio = [50, 350, 650, 950, 1250, 1550, 1850];

    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.search = e.target.value;
        this.currentPage = 1;
        this.cargarCarnets();
      }, 500);
    });

    document.getElementById('tipoFilter').addEventListener('change', (e) => {
      if (e.target.value === '') {
        delete this.filters.tipo_carnet;
      } else {
        this.filters.tipo_carnet = e.target.value;
      }
      this.currentPage = 1;
      this.cargarCarnets();
    });

    await this.cargarEstadisticas();
    await this.cargarCarnets();
  },

  async cargarEstadisticas() {
    try {
      const response = await posventaService.obtenerEstadisticas();
      const stats = response.data || response;
      document.getElementById('statTotal').textContent = stats.carnets?.total || 0;
      document.getElementById('statCertificados').textContent = stats.carnets?.certificados || 0;
      document.getElementById('statNoCertificados').textContent = stats.carnets?.no_certificados || 0;
      document.getElementById('statServiciosPendientes').textContent = stats.carnets?.servicios_pendientes || 0;
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarCarnets() {
    try {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        ...this.filters
      };

      const response = await posventaService.listarCarnets(params);
      const carnets = Array.isArray(response.data) ? response.data : [];
      const pagination = response.pagination || { page: 1, totalPages: 1, total: 0 };

      this.renderCarnets(carnets);
      this.renderPaginacion(pagination);
    } catch (error) {
      toast.error('Error al cargar carnets');
      console.error('Error:', error);
      this.renderCarnets([]);
    }
  },

  renderCarnets(carnets) {
    const tbody = document.getElementById('carnetsTableBody');

    if (!carnets || carnets.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="8" style="text-align: center; padding: 2rem;">No se encontraron carnets de servicio</td>
        </tr>
      `;
      return;
    }

    const tipoBadge = (c) => c.tipo_carnet === 'certificado'
      ? '<span class="badge badge-success">Certificado</span>'
      : '<span class="badge badge-secondary">No Certificado</span>';

    const estadoBadge = (c) => c.completada
      ? '<span class="badge badge-success">Completada</span>'
      : '<span class="badge badge-warning">Pendiente</span>';

    const serviciosLabel = (c) => {
      const count = c.servicios_count || 0;
      const total = this.intervalosServicio.length;
      return `<span style="color: ${count === total ? 'var(--success)' : 'var(--text-muted)'};">${count}/${total}</span>`;
    };

    const proximoLabel = (c) => c.proximo_servicio
      ? `${c.proximo_servicio} hrs`
      : '<span style="color: var(--success);">Completado</span>';

    const acciones = (c) => c.completada
      ? `${permisos.canView('servicios') ? `<button class="btn btn-sm btn-primary" onclick="window.carnetsListView.verDetalle(${c.id})">Ver</button>` : ''}`
      : `${permisos.canEdit('servicios') ? `<button class="btn btn-sm btn-primary" onclick="window.carnetsListView.verDetalle(${c.id})">Editar</button>` : ''}
         ${permisos.canDelete('servicios') ? `<button class="btn btn-sm btn-danger" onclick="window.carnetsListView.eliminarCarnet(${c.id})">Eliminar</button>` : ''}`;

    tbody.innerHTML = carnets.map(c => `
      <tr>
        <td>
          <button class="tbl-expand-btn" onclick="window.carnetsListView.toggleRow(${c.id})">&#9654;</button>
        </td>
        <td><strong>${c.num_serie}</strong></td>
        <td class="tbl-hide-mobile">${c.modelo || '-'} (${c.marca || '-'})</td>
        <td class="tbl-hide-mobile">${c.propietario}</td>
        <td class="tbl-hide-mobile">${tipoBadge(c)}</td>
        <td class="tbl-hide-mobile">${serviciosLabel(c)}</td>
        <td class="tbl-hide-mobile">${estadoBadge(c)}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.5rem;">${acciones(c)}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-carnet-${c.id}">
        <td colspan="8" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Modelo</dt><dd>${c.modelo || '-'} (${c.marca || '-'})</dd>
            <dt>Propietario</dt><dd>${c.propietario}</dd>
            <dt>Tipo</dt><dd>${tipoBadge(c)}</dd>
            <dt>Servicios</dt><dd>${serviciosLabel(c)}</dd>
            <dt>Próximo</dt><dd>${proximoLabel(c)}</dd>
            <dt>Estado</dt><dd>${estadoBadge(c)}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">
            ${acciones(c)}
          </div>
        </td>
      </tr>
    `).join('');
  },

  renderPaginacion(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;

    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let html = '<div style="display: flex; justify-content: center; gap: 0.5rem;">';
    html += `<button class="btn btn-sm btn-secondary" ${page <= 1 ? 'disabled' : ''} onclick="window.carnetsListView.cambiarPagina(${page - 1})">← Anterior</button>`;
    html += `<span style="padding: 0.5rem; font-size: 0.9rem;">Página ${page} de ${totalPages}</span>`;
    html += `<button class="btn btn-sm btn-secondary" ${page >= totalPages ? 'disabled' : ''} onclick="window.carnetsListView.cambiarPagina(${page + 1})">Siguiente →</button>`;
    html += '</div>';
    container.innerHTML = html;
  },

  cambiarPagina(page) {
    this.currentPage = page;
    this.cargarCarnets();
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-carnet-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      if (btn) btn.classList.toggle('expanded');
    }
  },

  limpiarFiltros() {
    document.getElementById('busqueda').value = '';
    document.getElementById('tipoFilter').value = '';
    this.filters = {};
    this.currentPage = 1;
    this.cargarCarnets();
  },

  verDetalle(id) {
    router.navigate(`/posventa/carnets/${id}`);
  },

  async eliminarCarnet(id) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar este carnet de servicio? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await posventaService.eliminarCarnet(id);
          toast.success('Carnet eliminado');
          await this.cargarCarnets();
          await this.cargarEstadisticas();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar carnet');
        }
      }
    );
  }
};
